module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Food/Beer-6acfe80cc103f9b18f1a7327d415fd24.svg";